import { render, staticRenderFns } from "./SendSMSDialog.vue?vue&type=template&id=3b8f16d6&"
import script from "./SendSMSDialog.vue?vue&type=script&lang=js&"
export * from "./SendSMSDialog.vue?vue&type=script&lang=js&"
import style0 from "./SendSMSDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports